import { HighlightIcon } from '@dev-spendesk/grapes';

import { PayableType } from 'src/core/modules/bookkeep/types';
import type { RequestType } from 'src/core/modules/requests/models/requestType';

type Props = {
  type: RequestType | PayableType;
};

export const TypeToHighlightIcon = ({ type }: Props) => {
  switch (type) {
    case 'card_load':
    case 'subscription_increase':
      return <HighlightIcon size={32} name="card-arrow-up" variant="purple" />;
    case PayableType.cardPurchase:
    case 'single_purchase':
      return <HighlightIcon size={32} name="card-lightning" variant="purple" />;
    case 'multi_use_card':
      return <HighlightIcon size={32} name="card-stack" variant="purple" />;
    case 'subscription':
      return (
        <HighlightIcon size={32} name="card-rounded-arrows" variant="purple" />
      );
    case PayableType.creditNote:
    case 'credit_note':
      return (
        <HighlightIcon
          size={32}
          name="document-uturn-left-top"
          variant="peach"
        />
      );
    case PayableType.invoicePurchase:
    case 'invoice':
      return <HighlightIcon size={32} name="document" variant="peach" />;
    case 'purchase_order':
      return <HighlightIcon size={32} name="shopping-cart" variant="ocean" />;
    case PayableType.claimedBill:
    case 'expense':
      return <HighlightIcon size={32} name="receipt" variant="lemon" />;
    case PayableType.mileageExpense:
    case 'mileage_allowance':
      return <HighlightIcon size={32} name="car" variant="lemon" />;
    case PayableType.perDiemExpense:
    case 'per_diem_allowance':
      return <HighlightIcon size={32} name="globe-eu-africa" variant="lemon" />;
    case PayableType.cardReversal:
      return (
        <HighlightIcon
          size={32}
          name="receipt-uturn-left-top"
          variant="purple"
        />
      );
    case 'travel_budget':
      return <HighlightIcon size={32} name="plane" variant="pink" />;
    default:
      return (
        <HighlightIcon size={32} name="receipt-question" variant="carbon" />
      );
  }
};
